import React from 'react';
import { NavLink } from "react-router-dom";
import mySalesLink from './style';
import { css } from "emotion";

const SalesLink = ({ toRouter }) => {
    return (
        <a
            className={css`${mySalesLink}`}
            href={toRouter}
            target="_blank"
        >
            <i className="icon-max-communication-info" />
            <p className="visible-xs visible-sm visible-md as-tooltip">Detalhe da venda</p>
        </a>
    )
}

export default SalesLink;